import styled from 'styled-components';

export const SetCardContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  backdrop-filter: blur(10px);
  justify-content: space-between;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 214px;
  position: relative;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.2);
  }

  ${props => !props.$isClickable && `
    opacity: 0.6;
    
    &:hover {
      transform: translateY(-2px);
      border-color: rgba(255, 255, 255, 0.2);
      background: rgba(255, 255, 255, 0.2);
      opacity: 1.0;
    }
  `}

  ${props => props.$isMultiSelectMode && `
    cursor: pointer;
    
    &:hover {
      border-color: rgba(76, 175, 80, 0.4);
      background: rgba(76, 175, 80, 0.1);
    }
  `}

  ${props => props.$isSelected && `
    border-color: rgba(76, 175, 80, 0.6);
    background: rgba(76, 175, 80, 0.15);
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
    
    &:hover {
      border-color: rgba(76, 175, 80, 0.8);
      background: rgba(76, 175, 80, 0.2);
    }
  `}
`;

export const SetName = styled.h3`
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const SetDescription = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0 0 12px 0;
  line-height: 1.4;
`;

export const SetTags = styled.div`
  margin: 8px 0;
`;

export const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagItem = styled.span`
  background: ${props => props.$isMoreIndicator 
    ? 'rgba(255, 255, 255, 0.05)' 
    : 'rgba(255, 255, 255, 0.1)'};
  border: 1px solid ${props => props.$isMoreIndicator 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(255, 255, 255, 0.2)'};
  border-radius: 12px;
  color: ${props => props.$isMoreIndicator 
    ? 'rgba(255, 255, 255, 0.6)' 
    : 'rgba(255, 255, 255, 0.8)'};
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  white-space: nowrap;
  font-style: ${props => props.$isMoreIndicator ? 'italic' : 'normal'};
`;

export const SetDates = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DatePill = styled.div`
  align-items: center;
  border: 2px solid rgba(255, 255, 255, 0.33);
  border-radius: 100px;
  display: flex;
  gap: 8px;
  height: 44px;
  padding: 0px 12px;
  transition: 0.4s;

  span {
    color: rgba(255, 255, 255, 0.8);
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
  }
`;